import { render, staticRenderFns } from "./guji-read.vue?vue&type=template&id=78cf882d&scoped=true&"
import script from "./guji-read.vue?vue&type=script&lang=ts&"
export * from "./guji-read.vue?vue&type=script&lang=ts&"
import style0 from "./guji-read.vue?vue&type=style&index=0&id=78cf882d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cf882d",
  null
  
)

export default component.exports